import { useTranslations } from '@lang';
import { TickCircleIcon } from '@root/styles/icons';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.defaultColors.darkGrey};
  font-size: 16px;
  background: #e6eef5;
  border-radius: 5px;
  padding: 0.5rem 0.25rem;
`;

const Icon = styled(TickCircleIcon)`
  width: 30px;
  height: 30px;
  color: ${({ theme }) => theme.defaultColors.darkGrey};
  margin: 0 7px;
`;

export const AddedToBasketBanner = () => {
  const { t } = useTranslations();

  return (
    <Wrapper>
      <Icon className="journey-icon" />
      {t('basket.addedConfirmationHeader')}
    </Wrapper>
  );
};
